import { Affix } from "ant-design-vue";
const { ...other } = Affix;
const YwAffix = {
	...other,
	name: "YwAffix",
};

YwAffix.install = function (Vue) {
	Vue.component(YwAffix.name, Affix);
};

export default YwAffix;
